import React from 'react'
import axios from 'axios'

const List = ( {items, label} ) => {
	return (
		items.length ?
		<div className={label}>
			<h2>Thanks to our {label} Tier Sponsor{items.length > 1 ? 's' : ''}!</h2>
			<div className="grid">
				{
					items.map( item => {
						return (
							<div className="media_container" key={item.id}>
								{item.url.length > 0 && (
									<a href={decodeURIComponent(item.url)} target="_blank" rel="noopener noreferrer" className="thumb">
										<img src={decodeURIComponent(item.icon)} alt={decodeURIComponent(item.name)} />
										<h3>{decodeURIComponent(item.name)}</h3>
									</a>
								)}
								{item.url.length === 0 && (
									<span className="thumb">
										<img src={decodeURIComponent(item.icon)} alt={decodeURIComponent(item.name)} />
										<h3>{decodeURIComponent(item.name)}</h3>
									</span>
								)}
							</div>
						)
					})
				}
			</div>
		</div> : null
	)
}

class Sponsors extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: [],
			gold: [],
			silver: [],
			bronze: []
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(id){
		axios.get('https://dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'sponsors'
			}
		}).then( response => {
			this.setState({
				items: response.data.items,
				gold: response.data.items.filter( item => item.tier === 'Gold' ),
				silver: response.data.items.filter( item => item.tier === 'Silver' ),
				bronze: response.data.items.filter( item => item.tier === 'Bronze' )
			})
		})
	}

	render() {
		return (
			this.state.items ?
				<section className="container sponsors">
						<List items={this.state.gold} label="Gold" />
						<List items={this.state.silver} label="Silver" />
						<List items={this.state.bronze} label="Bronze" />
				</section> :
			null
		)
	}
}

export default Sponsors



// WEBPACK FOOTER //
// ./src/components/sponsors.js